import clsx from 'clsx'
import React from 'react'
import { Logger } from 'wdc-cube'
import { bindUpdate, ViewSlot } from 'wdc-cube-react'

import { makeStyles } from 'tss-react/mui'

import { MenuItem } from '@mui/material'
import Box from '@mui/material/Box'
import Button from '@mui/material/Button'
import TextField from '@mui/material/TextField'
import { classToFComponent, FCClassContext } from 'src/utils/views'
import SerasaScope from '../serasa.scopes'
import SerasaExperianPF from './components/Experian-PF/SerasaExperianPFView'
import ExperianDadosEmpresa from './components/Experian-PJ/SerasaPJView'
import SerasaPerson from './components/Person/SerasaPersonView'
import SerasaPJ from './components/PJ/SerasaPJView'

const LOG = Logger.get('SERASA-VIEW')

const useStyles = makeStyles()({
    view: {
        position: 'relative',
        display: 'flex',
        flexDirection: 'column',
        padding: 10,
        minHeight: 600,
        rowGap: 10
    },
    cnpjInput: {
        flexGrow: 1
    },
    syncButton: {
        alignSelf: 'center'
    }
})

type SerasaViewProps = {
    className?: string
    scope: SerasaScope
}

class SerasaViewClass implements FCClassContext<SerasaViewProps> {
    // :: Fields
    scope!: SerasaScope
    sytles!: ReturnType<typeof useStyles>
    cpfInputRef!: React.MutableRefObject<HTMLInputElement | undefined>
    typeInputRef!: React.MutableRefObject<HTMLInputElement | undefined>

    // :: emissors

    readonly emitOnFind = () => {
        this.scope.cpfCnpjSelected = this.cpfInputRef.current?.value || ''
        this.scope.typeSelected = this.typeInputRef.current?.value || ''
        this.scope.onFind().catch(LOG.caught)
    }

    // :: Methods

    onSyncState({ scope }: SerasaViewProps) {
        this.scope = scope
        this.sytles = useStyles()
    }

    render({ className, scope }: SerasaViewProps) {
        this.scope = bindUpdate(React, scope)
        this.cpfInputRef = React.useRef<HTMLInputElement>()
        this.typeInputRef = React.useRef<HTMLInputElement>()

        const classes = this.sytles.classes

        if (scope.waiting) {
            return <ViewSlot scope={scope.waiting} />
        }

        return (
            <div className={clsx(classes.view, className)}>
                <Box display="flex" flexDirection="row" alignItems="baseline" gap="10px">
                    <TextField
                        defaultValue={this.scope.cpfCnpjSelected}
                        className={classes.cnpjInput}
                        inputRef={this.cpfInputRef}
                        label="Cole ou escreva o CPF ou CNPJ aqui"
                        variant="standard"
                        fullWidth
                    />
                    <TextField
                        select
                        inputRef={this.typeInputRef}
                        defaultValue={this.scope.typeSelected}
                        fullWidth
                        label="Origem dos dados"
                    >
                        <MenuItem value="motor">Modo Motor</MenuItem>
                        <MenuItem value="serasa">Serasa</MenuItem>
                        <MenuItem value="experian">Serasa Experian</MenuItem>
                    </TextField>

                    <Button variant="outlined" onClick={this.emitOnFind}>
                        Buscar
                    </Button>
                </Box>
                {this.scope.person && this.scope.person.identificacao && <SerasaPerson person={this.scope.person} />}
                {this.scope.empresa && this.scope.empresa.identificacao && <SerasaPJ empresa={this.scope.empresa} />}
                {this.scope.experianPessoa && this.scope.experianPessoa.reports && (
                    <SerasaExperianPF pfReport={this.scope.experianPessoa} />
                )}
                {this.scope.experianEmpresa && this.scope.experianEmpresa.reports && (
                    <ExperianDadosEmpresa businness={this.scope.experianEmpresa!} />
                )}
            </div>
        )
    }
}

export const SerasaView = classToFComponent(SerasaViewClass, React)
export default SerasaView
